import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import RegisterEndorsementRequest from '../../commons/mappings/registerEndorsementRequest.mapping';

class RegisterEndorsementProvider {

    constructor() {
        this.paths                      = URLConfiguration.paths;
        this.registerEndorsementRequest = new RegisterEndorsementRequest();
        this.apiProvider                = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
    }

    registrarSolicitudEndoso = async (datosPoliza) => {
        const headers   = HeadersMapping.getHeaderService();
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.poliza.registrarEndosoPoliza, datosPoliza);
        const request   = this.registerEndorsementRequest.getRegisterEndorsement(datosPoliza);
        let response    = null;
        try {
            response = await this.apiProvider.post(pathNew, request, { headers });
        } catch (error) {
            console.log(error);
            response = {
                'data' : {
                    'datos' : {
                        'numeroSolicitudEndoso' : 0,
                        'numeroSolicitudServicio' : '',
                        'codError'  : error.code,
                        'descError' : error.message
                    }
                }
            }
        }
        return response;
    }

}

export default RegisterEndorsementProvider;